"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const CheckboxList_module_scss_1 = __importDefault(require("./CheckboxList.module.scss"));
const CheckboxList = ({ children, className, ...props }) => {
    return ((0, jsx_runtime_1.jsx)("section", { className: (0, classnames_1.default)(CheckboxList_module_scss_1.default.section, className), ...props, children: children }));
};
exports.default = CheckboxList;
